<template>
    <div id="container" type="vdpp">
        <div class="page page-feed" v-ga:request="{pageType:'vfeed', state: {}}" v-ga:page="{pageType:'vfeed', glb: glb, state: {}}">
            <mvtHeader />
            <mvtFeed :isNotification="isNotification"></mvtFeed>
            <mvtFooter />
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-feed.js"></script>

<style lang="scss">
@use "./page-feed.scss" as *;
</style>